export const getFullName = (names: string, lastname1: string, lastname2?: string): string => {
  return `${names} ${lastname1}${lastname2 ? ` ${lastname2}` : ''}`
}

export const getDoctorFullName = (name: string, surname1: string, surname2?: string): string => {
  const thereIsDoctor = name && surname1

  return thereIsDoctor ? `${surname1}${surname2 ? ` ${surname2}` : ''}, ${name}` : ''
}
